<template>
    <div class="live-column-detail">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item>1</van-swipe-item>
        </van-swipe>

        <van-tabs :swipeable="true" :sticky="true" animated :background="'#f2f2f2'">
            <van-tab :title="'目录'" class="live-column-list">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                    <van-cell v-for="(item,index) in list" :key="item" @click="$router.push({name:'live-detail',params: { id: 1 }})">
                        <div class="live-column-list-title">{{index+1}} {{item.title}}</div>
                        <div class="live-column-list-detail">
                            <div>
                                2020年12月16日
                                <van-icon name="play-circle-o" color="#333" />
                                3309
                            </div>
                            <div class="float-right">{{item.price == '0' ? "免费" : item.price+"博贝"}}</div>
                        </div>
                    </van-cell>
                </van-list>
            </van-tab>
            <van-tab :title="'介绍'" class="live-column-intro">
                <p>课程背景介绍</p>
                <p>
                    为帮助广大消化肝病科医生进一步明晰丙肝现状及规范化诊治，中国医学论坛报·壹生特别邀请北京大学人民医院、北京大学肝病研究所饶慧瑛教授共同策划，推出《丙肝临床20问》系列课程，每课一问，围绕丙肝诊治前后存在的常见临床问题展开讲授，共同规范丙肝诊治。
                </p>
                <p>课程表</p>
            </van-tab>
        </van-tabs>

        <van-goods-action>
            <van-goods-action-icon icon="star" text="已收藏" color="#ff5000"/>
            <van-goods-action-icon icon="share" text="分享" @click="onClickIcon"/>
            <van-goods-action-button type="danger" text="1200博币购买专栏" @click="onClickButton"/>
        </van-goods-action>
    </div>
</template>

<script>
    import Interface from "@/util/interface"
    import columnSkeleton from "@/skeleton/columnSkeleton"
    export default {
        name: 'live-column',
        components :{
            'column-skeleton' : columnSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                list: [],
                loading: true,
                finished: false,
            }
        },
        methods : {
            fetch(scene) {
                if (scene === 'column_detail') {
                    Interface.getData('get', Interface.live.column.detail).then((res) => {
                        this.detail = res.data.data
                    })
                }
            },
            onLoad() {
                // 加载状态结束
                this.loading = false;
                // 数据全部加载完成
                if (this.list.length >= 40) {
                    this.finished = true;
                }
            },
        },
        created() {
            this.fetch('column_detail')
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/live/column_detail/index.vue